<template>
  <div id="dashboard">
    <Navigation class="nav"/>

    <Header
      :title="title"
      v-on:handleNavigation="openNavigation"
    />

    <div class="dashboard--content">      
      <slot></slot>
    </div>
  </div>
</template>

<script>
  import Navigation from './navigation/navigation.vue';  
  import Header from './header/header.vue';

  export default {
    name: 'Dashboard',
    components: {
      Navigation,
      Header
    },
    props: [
      'title'
    ],
    methods: {
      openNavigation: function() {
        const navigation = document.querySelector('.nav');

        // navigation.classList.add('nav--show');

        navigation.style.opacity = '1';
        navigation.style.visibility = 'visible';
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/mediaQueries.scss";

  #dashboard {

    .dashboard--content {
      width: calc(100% - var(--navigation-width));
      padding: 90px 30px 30px 30px;
      margin-left: var(--navigation-width);

      @include media-sm {
        padding: 55px 15px 15px 15px;
        margin-left: 0;
      }      
    }
  }  
</style>
